import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-7b34a4d8")
const _hoisted_1 = { class: "trinket-grid-text" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextToolbar = _resolveComponent("TextToolbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: "textElement",
      class: _normalizeClass([{ selected: _ctx.selected }, "text"]),
      style: _normalizeStyle({ ..._ctx.style, ..._ctx.position }),
      contenteditable: "true",
      onFocus: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSelect && _ctx.onSelect(...args))),
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateText && _ctx.updateText(...args)))
    }, _toDisplayString(_ctx.mutatedText.text), 39),
    _withDirectives(_createVNode(_component_TextToolbar, {
      ref: "toolbarElement",
      style: _normalizeStyle(_ctx.toolbarPosition),
      fontColor: _ctx.mutatedText.color,
      fontSize: parseInt(_ctx.mutatedText.fontSize, 10),
      onCancel: _ctx.cancel,
      onConfirm: _ctx.confirm,
      onRemove: _ctx.remove,
      "onUpdate:fontColor": _ctx.updateFontColor,
      "onUpdate:fontSize": _ctx.updateFontSize
    }, null, 8, ["style", "fontColor", "fontSize", "onCancel", "onConfirm", "onRemove", "onUpdate:fontColor", "onUpdate:fontSize"]), [
      [_vShow, _ctx.selected]
    ])
  ]))
}